export const CARD_GRADIENTS = [
  ['#FF3366', '#FF0099', '#6600FF'],
  ['#1A1A1A', '#2A2A2A'],
  ['#00B8D4', '#00E5FF'],
  ['#FF6B6B', '#FFE66D'],
  ['#4CAF50', '#8BC34A'],
  ['#9C27B0', '#E91E63'],
  ['#3F51B5', '#2196F3']
] as const;

